import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import { AuthProvider } from "@/auth/AuthContext";
import AuthGate from "@/auth/AuthGate";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AuthGate>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
            </Routes>
          </BrowserRouter>
        </AuthGate>
      </AuthProvider>
    </div>
  );
}

export default App;
